var _polygon, _path, _polygon2, _path2, _polygon3, _path3, _circle, _rect, _path4, _path5, _circle2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _path6, _path7, _path8, _polygon4, _polygon5, _polygon6, _polygon7, _path9, _path0, _circle3, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _polygon8, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTip4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a259f86b-03f4-47ac-adca-e0b316d45eda",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 888,
    height: 650.61216,
    viewBox: "0 0 888 650.61216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mobile_devices") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "467.054 645.101 459.629 645.101 462.104 499.91 464.579 499.91 467.054 645.101",
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M628.91087,533.06384l11.96486-18.49113a277.22087,277.22087,0,0,0-12.2752-28.735l-7.73686,6.249,6.12606-9.46746c-5.83819-11.49226-10.432-18.733-10.432-18.733s-23.99591,37.81367-32.0128,77.84976l15.35368,23.72848-16.9972-13.72856a112.157,112.157,0,0,0-.93251,14.06385c0,47.4161,15.48592,85.85444,34.58883,85.85444s34.58884-38.43834,34.58884-85.85444c0-14.69945-3.32549-30.07832-7.91284-44.30428Z",
    transform: "translate(-156 -124.69392)",
    fill: "#e6e6e6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "279.016 645.101 271.592 645.101 274.067 499.91 276.541 499.91 279.016 645.101",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M443.65709,533.06384,455.622,514.57271a277.221,277.221,0,0,0-12.27519-28.735l-7.73686,6.249,6.12606-9.46746c-5.83819-11.49226-10.432-18.733-10.432-18.733s-23.99592,37.81367-32.0128,77.84976l15.35368,23.72848-16.9972-13.72856a112.157,112.157,0,0,0-.93252,14.06385c0,47.4161,15.48593,85.85444,34.58884,85.85444s34.58883-38.43834,34.58883-85.85444c0-14.69945-3.32549-30.07832-7.91283-44.30428Z",
    transform: "translate(-156 -124.69392)",
    fill: "#e6e6e6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "371.285 644.652 356.436 644.652 361.386 346.022 366.336 346.022 371.285 644.652",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M540.19374,282.43224l24.67038-38.12691a571.604,571.604,0,0,0-25.31026-59.24885l-15.95265,12.88475,12.63135-19.521c-12.03779-23.69593-21.50982-38.62564-21.50982-38.62564s-49.47724,77.96811-66.00727,160.51863l31.65779,48.92581-35.04657-28.307a231.25563,231.25563,0,0,0-1.92276,28.9983c0,97.76736,31.93048,177.02347,71.31881,177.02347s71.31881-79.25611,71.31881-177.02347c0-30.30885-6.85684-62.01857-16.3155-91.35111Z",
    transform: "translate(-156 -124.69392)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 299.19458,
    cy: 68.47053,
    r: 68.47053,
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 644.24023,
    width: 888,
    height: 2.24072,
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M955.23238,417.116a2.82152,2.82152,0,0,0,2.82152-2.82153V384.19819a2.79442,2.79442,0,0,0-3.762-2.64874v-34.031a9.40506,9.40506,0,0,0-9.40507-9.40508H637.34086a9.40506,9.40506,0,0,0-9.40507,9.40508V760.40116a9.4051,9.4051,0,0,0,9.40507,9.40508H944.8868a9.4051,9.4051,0,0,0,9.40507-9.40508V459.266a2.79444,2.79444,0,0,0,3.762-2.64874V426.521a2.79444,2.79444,0,0,0-3.762-2.64874v-6.92912A2.79526,2.79526,0,0,0,955.23238,417.116Z",
    transform: "translate(-156 -124.69392)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M926.07666,356.45321a9.40508,9.40508,0,0,1,9.40509,9.40509v376.203a9.4051,9.4051,0,0,1-9.40509,9.405H656.151a9.40511,9.40511,0,0,1-9.40506-9.405V365.8583a9.40509,9.40509,0,0,1,9.40506-9.40509H926.07666",
    transform: "translate(-156 -124.69392)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.11383,
    cy: 222.82448,
    r: 3.76203,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 515.63891,
    y: 281.11007,
    width: 231.16914,
    height: 22.97312,
    fill: "#edd84f"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 515.63891,
    y: 335.22412,
    width: 231.16914,
    height: 8.70119,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 515.63891,
    y: 361.78229,
    width: 231.16914,
    height: 8.70119,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 515.63891,
    y: 388.67686,
    width: 119.44476,
    height: 8.70119,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 515.63891,
    y: 416.0488,
    width: 231.16914,
    height: 8.70119,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 515.63891,
    y: 443.42074,
    width: 231.16914,
    height: 8.70119,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 515.63891,
    y: 470.79268,
    width: 115.44476,
    height: 8.70119,
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 515.63891,
    y: 498.16461,
    width: 231.16914,
    height: 8.70119,
    fill: "#e6e6e6"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 515.63891,
    y: 525.53655,
    width: 231.16914,
    height: 8.70119,
    fill: "#e6e6e6"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 674.08367,
    y: 559.11007,
    width: 73,
    height: 24,
    fill: "#edd84f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M423.9461,490.77611h-1.64458V436.00073a31.83907,31.83907,0,0,0-31.83907-31.83907H273.78523a31.83912,31.83912,0,0,0-31.83913,31.83913V737.9671a31.83913,31.83913,0,0,0,31.83913,31.83914H390.46245a31.83907,31.83907,0,0,0,31.83907-31.83907V529.6978h1.64458Z",
    transform: "translate(-156 -124.69392)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M415.175,433.81689V737.257a23.77813,23.77813,0,0,1-23.77813,23.77813H274.49531A23.77813,23.77813,0,0,1,250.71718,737.257V433.81689a21.43234,21.43234,0,0,1,21.43234-21.43234h16.50482a11.60266,11.60266,0,0,0,.50568,9.7111,11.34186,11.34186,0,0,0,9.278,5.6383h68.01342a11.34117,11.34117,0,0,0,9.27827-5.639,11.60375,11.60375,0,0,0,.50511-9.71037h17.50788A21.43234,21.43234,0,0,1,415.175,433.81689Z",
    transform: "translate(-156 -124.69392)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M550.63194,351.45782s-12.40214-4.42933-20.37494,13.288-20.37494,37.20641-20.37494,37.20641L516.969,403.724s1.77174-12.40214,6.20107-14.17387l-1.77173,15.9456s53.152,18.60321,77.07043-1.77173l-.88586-6.20107s3.54346.88587,3.54346,6.20107l2.65761-2.6576s-2.65761-5.31521-10.63041-12.40214c-5.233-4.65156-7.03129-13.50109-7.64926-19.034a23.03336,23.03336,0,0,0-5.3029-12.54328C574.90306,350.94653,565.24875,344.4201,550.63194,351.45782Z",
    transform: "translate(-156 -124.69392)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "321.794 378.753 333.391 393.513 340.772 385.078 334.446 374.535 321.794 378.753",
    fill: "#fbbebe"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "317.577 605.429 313.36 627.569 323.903 632.841 331.283 627.569 331.283 605.429 317.577 605.429",
    fill: "#fbbebe"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "391.378 605.429 395.596 627.569 385.053 632.841 377.672 627.569 377.672 605.429 391.378 605.429",
    fill: "#fbbebe"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "348.152 406.165 333.391 511.595 312.305 607.538 337.609 610.701 357.641 521.084 382.944 445.174 379.781 535.845 374.51 610.701 393.487 610.701 407.193 509.487 422.349 434.236 421.953 406.165 348.152 406.165",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M476.73977,750.15475s-5.27154-6.32585-8.43447-3.16293-10.54309,15.81464-10.54309,15.81464-16.86894,9.48877-3.16292,11.59739,17.92324,0,17.92324-1.05431,2.10862-4.21723,2.10862-4.21723l5.27155,1.05431,7.38016-2.10862s3.16292-19.42585,0-18.67455S477.79408,753.31768,476.73977,750.15475Z",
    transform: "translate(-156 -124.69392)",
    fill: "#2f2e41"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M544.21553,750.15475s5.27154-6.32585,8.43446-3.16293,10.54309,15.81464,10.54309,15.81464,16.86894,9.48877,3.16293,11.59739-17.92325,0-17.92325-1.05431-2.10862-4.21723-2.10862-4.21723l-5.27154,1.05431-7.38016-2.10862s-3.16293-19.42585,0-18.67455S543.16122,753.31768,544.21553,750.15475Z",
    transform: "translate(-156 -124.69392)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 398.23146,
    cy: 260.14287,
    r: 21.08617,
    fill: "#fbbebe"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M568.46462,398.01565s-2.10861,17.92325-1.0543,22.14048,3.16292,10.54309,3.16292,10.54309l-33.73788-6.32585s9.48878-20.03187,7.38017-23.19479S568.46462,398.01565,568.46462,398.01565Z",
    transform: "translate(-156 -124.69392)",
    fill: "#fbbebe"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M571.62755,423.31906l-34.79219-7.38016L516.8035,538.23871a45.67558,45.67558,0,0,1,27.412,1.0543c14.76032,5.27155,34.79218,0,34.79218,0l-4.21723-114.91964Z",
    transform: "translate(-156 -124.69392)",
    fill: "#edd84f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M543.92175,406.25262,531.56382,412.776l-15.81463,3.16293-16.86894,40.06373,2.10862,28.46633s-17.92325,32.68357-20.03187,50.60682c0,0,2.10862,27.412,36.90081,26.35772l23.19479-64.31283s9.48878-48.4982,0-62.20421C541.0526,434.91646,547.84522,409.21805,543.92175,406.25262Z",
    transform: "translate(-156 -124.69392)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M522.075,415.9389l-3.41389-.58239-2.912.58239s-7.38016,1.05431-15.81463,8.43447-36.9008,30.575-39.00942,36.9008-1.05431,16.86894,2.10862,23.19479,9.48877,14.76033,9.48877,14.76033l3.16293,7.38016,17.92325-5.27155s-11.5974-22.14048-10.54309-31.62926L504.1518,452.8397Z",
    transform: "translate(-156 -124.69392)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M567.29714,411.01913,583.225,430.69922l8.43447,10.54309L581.11633,477.0888l-5.27154,30.575s12.6517,48.4982,2.10861,63.25853c0,0-6.32585,7.38016-8.43447-1.05431s-2.10861-48.4982-2.10861-48.4982-8.43447-52.71544-4.21724-66.42145S562.96672,413.47951,567.29714,411.01913Z",
    transform: "translate(-156 -124.69392)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M582.17064,563.54211V574.0852s-2.10862,34.79219,8.43447,30.575,3.16292-30.575,3.16292-30.575l-1.05431-11.59739Z",
    transform: "translate(-156 -124.69392)",
    fill: "#fbbebe"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M530.72627,385.961c8.0189-5.8034,14.51-12.48772,18.80392-20.43905,0,0,14.71612,16.35124,23.70931,17.1688s.81756-19.62149.81756-19.62149l-16.35124-4.08781-15.53368,1.63513-12.26343,8.17562Z",
    transform: "translate(-156 -124.69392)",
    fill: "#2f2e41"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "427.225 313.385 435.659 316.548 436.714 327.091 440.931 391.404 438.822 439.903 423.008 440.957 417.736 387.187 415.628 328.146 427.225 313.385",
    fill: "#2f2e41"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 112.63891,
    y: 373.68882,
    width: 128.15439,
    height: 12.73572,
    fill: "#edd84f"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 112.63891,
    y: 403.6883,
    width: 128.15439,
    height: 4.82372,
    fill: "#e6e6e6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 112.63891,
    y: 418.41148,
    width: 128.15439,
    height: 4.82372,
    fill: "#e6e6e6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 112.63891,
    y: 433.32116,
    width: 66.21719,
    height: 4.82372,
    fill: "#e6e6e6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 112.63891,
    y: 448.49548,
    width: 128.15439,
    height: 4.82372,
    fill: "#e6e6e6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 112.63891,
    y: 463.6698,
    width: 128.15439,
    height: 4.82372,
    fill: "#e6e6e6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 112.63891,
    y: 478.84412,
    width: 63.99969,
    height: 4.82372,
    fill: "#e6e6e6"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 112.63891,
    y: 494.01843,
    width: 128.15439,
    height: 4.82372,
    fill: "#e6e6e6"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 112.63891,
    y: 509.19275,
    width: 128.15439,
    height: 4.82372,
    fill: "#e6e6e6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 200.47672,
    y: 527.80507,
    width: 40.46937,
    height: 13.305,
    fill: "#edd84f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip4);
export default __webpack_public_path__ + "static/media/tip4.8c4e04a920456cd4897329bd076e85b2.svg";
export { ForwardRef as ReactComponent };